<yat-billing-address-selection-common id="ddac675b-044c-4cbe-80aa-8340525aee43"
  [updateSubscriptionWithContractId]="managedContractId$ | async"
  [billingAddresses$]="billingAddresses$"
  [selectedBillingAddress$]="selectedBillingAddress$"
  (saveSelection)="saveSelectedBillingAddress($event)"
  (prepareDeleteAddress)="prepareDeleteBillingAddress($event)"
  (deleteAddress)="deleteBillingAddress($event)">
</yat-billing-address-selection-common>
